import { FormControlLabel, FormControlLabelProps, Radio, SxProps, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';

export type VyRadioProps = {
  label: ReactNode;
  value: unknown;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  labelSx?: SxProps<Theme>;
  baseLineAlignment?: boolean;
  cardMode?: boolean;
  selected?: boolean;
  disabled?: boolean;
};

export const VyRadio: FC<VyRadioProps> = ({
  value,
  label,
  labelPlacement,
  baseLineAlignment = true,
  labelSx = {},
  cardMode = false,
  selected = false,
  disabled = false,
}) => {
  const cardStyles: SxProps<Theme> = cardMode ? createCardStyles(selected) : {};

  return (
    <FormControlLabel
      value={value}
      control={<Radio />}
      label={label}
      disabled={disabled}
      labelPlacement={labelPlacement}
      sx={
        {
          margin: 0,
          ...labelSx,
          ...cardStyles,
          ...(baseLineAlignment &&
            !cardMode && {
              alignItems: baseLineAlignment ? 'flex-start' : 'center',

              '& .MuiRadio-root': {
                marginTop: '-10px',
              },
            }),
        } as SxProps<Theme>
      }
    />
  );
};

function createCardStyles(selected: boolean): SxProps<Theme> {
  return {
    flex: 1,
    padding: 3,
    border: `1px solid ${selected ? '#5083FF' : '#E8EBF2'}`,
    borderRadius: '8px',
    cursor: 'pointer',
    backgroundColor: selected ? '#F5F6FA' : '#fff',
    transition: 'all 0.2s ease-in-out',
    ...(!selected && {
      '&:hover': {
        borderColor: '#B0D2FF',
        backgroundColor: '#F5F6FA',
      },
    }),
    alignItems: 'flex-start',
    '& .MuiRadio-root': {
      marginTop: '-4px',
      '&.Mui-checked': {
        color: '#05489C',
      },
    },
  };
}
